import React, { useState,  useEffect } from 'react';
import styles from './Login.module.css';
import logo from '../../shreeohmlogo.png';
import axios from 'axios';
import { NavLink, useNavigate } from 'react-router-dom';
import config from '../../config/config';

const Login = () => {
  const navigate = useNavigate();
useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      navigate('/');
    }
  }, []);
  
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMsg, setErrorMsg] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    setErrorMsg('');
  
    try {
      const response = await axios.post(`${config.apiBaseUrl}/api/users/login`, {
        email,
        password,
      });
  
      // Assuming the token is returned in response.data.token
      if (response.data.message === 'Login successful!') {
        // Store the JWT token in localStorage
        localStorage.setItem('token', response.data.token); // <-- Save the token
  
        localStorage.setItem('username', response.data.username); // Save username
        localStorage.setItem('userId', response.data.userId); // Save userId
        localStorage.setItem('userData', JSON.stringify({ _id: response.data.userId, email }));
        navigate('/'); // Redirect to home page
      }
    } catch (error) {
      if (error.response && error.response.data.message) {
        setErrorMsg(error.response.data.message);
      } else {
        setErrorMsg('Something went wrong. Please try again.');
      }
    }
  };
  

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.logoContainer}>
          <img src={logo} alt="Shree OHM Logo" className={styles.logo} />
        </div>
        <h1 className={styles.title}>Login</h1>

        {errorMsg && <div className={styles.error}>{errorMsg}</div>}

        <form className={styles.form} onSubmit={handleLogin}>
          <div className={styles.inputGroup}>
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              className={styles.input}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div className={styles.inputGroup}>
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              className={styles.input}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <a href="/forgot-password" className={styles.forgotPassword}>Forgot Password ??</a>
          <button type="submit" className={styles.loginButton}>Login</button>
        </form>

        <p className={styles.registerText}>
          Don't have an account ?? <NavLink to="/shreeohm/registration" className={styles.registerLink}>Register</NavLink>
        </p>
      </div>
    </div>
  );
};

export default Login;
